import { FormikHelpers } from "formik";
import { emailChecker } from "./EmailChecker";
import { retryCreateProposalBank } from "@/services/proposal.service";
import { Proposal } from "@/models/proposal.model";
import { dateFormatter } from "./dateFormatter";

type RetryProposalParams = {
  values: any;
  proposal: Proposal | undefined;
  createProposalBank?: boolean;
  createIdentitySecurity?: boolean;
   actions?: FormikHelpers<any>;
  onSuccess?: () => void;
  onError?: () => void;
};

export const retryProposalUtil = async ({
  values,
  actions,
  proposal,
  createProposalBank = true,
  createIdentitySecurity = false,
  onSuccess,
  onError,
}: RetryProposalParams) => {
  try {
    // validação do e-mail PIX
    if (values.pixKeyType === "EMAIL" && values.pixKey && !emailChecker(values.pixKey)) {
      actions?.setSubmitting(false);
      return;
    }

    if (values.pixKeyType === "PHONE" || values.pixKeyType === "DOCUMENT") {
      values.pixKey = values.pixKey?.replace(/\D/g, "");
    }
    if (values.pixKeyType === "EMAIL" && values.pixKey) {
      values.pixKey = values.pixKey.toLowerCase();
    }

    // console.log({values})
    
    const NaturalPerson = {
      id: proposal?.naturalPersonId,
      name: values.name,
      motherName: values.motherName,
      birthDate: dateFormatter(values?.birthDate),
      email: values.email?.toLowerCase(),
      // birthDate: values.birthDate,
      document: values.document || values.cpf,
      documentType: "CPF",
      phoneNumber: values?.phoneNumber?.replace(/\D/g, "") || values?.cellphone?.replace(/\D/g, ""),
      addressId: null,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      address: {
        id: proposal?.NaturalPerson?.addressId,
        addressName: values.street,
        number: values.streetNumber?.toString() || values?.number?.toString(),
        zipCode: values?.cep?.replace("-", ""),
        district: values.district,
        city: values.city,
        uf: values.state,
        complement: values.complement,
      },
    };
    const pixKeyType = values?.pixType || values?.pixKeyType

    const BankDetail = {
      id: proposal?.BankDetail?.id,
      pixKeyType,
      pixKey: pixKeyType === "BANK_ACCOUNT" ? null : values.pixKey,
      accountDigit: pixKeyType !== "BANK_ACCOUNT" ? null : values.digit || values.accountDigit,
      account: pixKeyType !== "BANK_ACCOUNT" ? null : values.account,
      agency: pixKeyType !== "BANK_ACCOUNT" ? null : values.agency,
      accountType: pixKeyType !== "BANK_ACCOUNT" ? null : values.accountType,
      bankCode: pixKeyType !== "BANK_ACCOUNT" ? null : values.bankCode,
      Bank: {
        id: pixKeyType !== "BANK_ACCOUNT" ? null : values.bankCode,
        name: pixKeyType !== "BANK_ACCOUNT" ? null : values.Bank?.name,
        ispb: pixKeyType !== "BANK_ACCOUNT" ? null : values.Bank?.ispb,
      },
    };

    const retryProposal = {
      proposalRequest: {
        balanceSolicitationId: proposal?.balanceSolicitationId,
        NaturalPerson,
        chosenFinancialInfo: {
          ...proposal?.chosenFinancialInfo!,
          proposalId: proposal?.chosenFinancialInfo?.externalId!,
        },
        BankDetail,
      },
      createProposalBank,
      createIdentitySecurity,
    };

    // console.log("retryProposal payload", retryProposal);

    await retryCreateProposalBank(proposal?.id!, retryProposal);

    onSuccess?.();
  } catch (error) {
    onError?.();
  } finally {
    actions?.setSubmitting(false);
  }
};
